export const generateGuid = (): string => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }
    );
};

export const getEmptyGuid = (): string => {
    return '00000000-0000-0000-0000-000000000000';
};

export const areValuesEqual = (value1: number | null | undefined, value2: number | null | undefined): boolean => {
    if (value1 === null || value1 === undefined || value2 === null || value2 === undefined) {
        return value1 === value2;
    }
    
    const num1 = Number(value1);
    const num2 = Number(value2);
    
    if (isNaN(num1) || isNaN(num2)) {
        return value1 === value2;
    }
    
    return Math.abs(num1 - num2) < 0.01;
};